import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.navbar');
import { OnInit, ChangeDetectorRef as CDR, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { IUser } from '../@types';

const THEME_KEY = 'inspectpro-theme';

@Component({
    selector: 'wiz-layout-navbar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.navbar/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}`],
})
export class LayoutNavbarComponent implements OnInit {
    public user: IUser | null = null;
    public isDark: boolean = false;
    public scrolled: boolean = false;

    public menus = [
        { label: '대시보드', path: '/main', icon: 'fa-solid fa-chart-line' },
        { label: '용역 관리', path: '/project/list', icon: 'fa-solid fa-folder-open' },
        { label: '체크리스트', path: '/checklist/list', icon: 'fa-solid fa-clipboard-check' },
    ];

    public showDropdown: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR,@Inject( ElementRef)  private eRef: ElementRef) { }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.showDropdown) return;
        const wrap = this.eRef.nativeElement.querySelector('.dropdown-wrap');
        if (wrap && !wrap.contains(event.target as Node)) {
            this.closeDropdown();
        }
    }

    public async ngOnInit() {
        await this.service.init(this);

        this.isDark = localStorage.getItem(THEME_KEY) === 'dark';
        this.applyTheme();

        try {
            if (!this.service.auth.allow(true, '/login')) return;
            await this.loadSession();
        } catch (e) {
            console.error('Navbar session load error:', e);
        } finally {
            await this.service.loading.hide();
        }

        this.ref.detectChanges();
    }

    public async loadSession() {
        const { code, data } = await wiz.call('session');
        if (code !== 200) {
            location.href = '/login';
            return;
        }
        this.user = data;
        this.ref.detectChanges();
    }

    public isActive(path: string): boolean {
        const current = location.pathname;
        if (path === '/main') return current === '/main' || current === '/';
        return current.startsWith(path);
    }

    public onScroll(event: any) {
        const newScrolled = event.target.scrollTop > 10;
        if (this.scrolled !== newScrolled) {
            this.scrolled = newScrolled;
            this.ref.detectChanges();
        }
    }

    public toggleTheme() {
        this.isDark = !this.isDark;
        localStorage.setItem(THEME_KEY, this.isDark ? 'dark' : 'light');
        this.applyTheme();
        this.ref.detectChanges();
    }

    private applyTheme() {
        const html = document.documentElement;
        if (this.isDark) {
            html.classList.add('dark');
        } else {
            html.classList.remove('dark');
        }
    }

    public toggleDropdown() {
        this.showDropdown = !this.showDropdown;
        this.ref.detectChanges();
    }

    public closeDropdown() {
        this.showDropdown = false;
        this.ref.detectChanges();
    }

    public async logout() {
        await wiz.call('logout');
        location.href = '/login';
    }
}

export default LayoutNavbarComponent;